import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import type { AuditLogWithUser } from '@cdw-ae/common-data';
import { ICdwSearchGridDataService } from '@cdw-ae/common-ui-components-search-grid';
import type {
  IGetSqlDataParams,
  SqlResponse,
} from '@cdw-ae/filter-bar-interfaces';
import { Observable } from 'rxjs';
import { ApiUrlBuilderService } from '../../../../../common/services/api-url-builder.service';

@Injectable({
  providedIn: 'root',
})
export class AuditLogDataService
  implements ICdwSearchGridDataService<AuditLogWithUser>
{
  constructor(
    private httpClient: HttpClient,
    private readonly urlBuilder: ApiUrlBuilderService
  ) {}

  /**
   * Required by ICdwSearchGridDataService - called by search grid
   * Uses authenticated endpoint - customerId comes from user claims in backend
   */
  public fetchSqlData(
    params: IGetSqlDataParams
  ): Observable<SqlResponse<AuditLogWithUser>> {
    const {
      activeFilters,
      startRow,
      endRow,
      supplementalFilters,
      sortOrder,
    }: IGetSqlDataParams = params;

    const searchParams: IGetSqlDataParams = {
      activeFilters: activeFilters || [],
      startRow,
      endRow,
      supplementalFilters: supplementalFilters || [],
      ...(sortOrder?.length ? { sortOrder } : {}),
    };

    const url = this.urlBuilder.backendApi('audit-log', 'search');
    return this.httpClient.post<SqlResponse<AuditLogWithUser>>(url, searchParams);
  }

  /**
   * Search audit logs using filter bar filters
   * Uses authenticated endpoint - customerId comes from user claims in backend
   */
  public searchAuditLogs(
    searchParams: IGetSqlDataParams
  ): Observable<SqlResponse<AuditLogWithUser>> {
    const url = this.urlBuilder.backendApi('audit-log', 'search');
    return this.httpClient.post<SqlResponse<AuditLogWithUser>>(url, searchParams);
  }

  /**
   * Get audit logs for a specific user
   * Uses authenticated endpoint - customerId comes from user claims in backend
   */
  public getAuditLogsByUser(
    userId: number,
    startRow = 0,
    endRow = 100
  ): Observable<SqlResponse<AuditLogWithUser>> {
    const searchParams: IGetSqlDataParams = {
      activeFilters: [],
      startRow,
      endRow,
      supplementalFilters: [
        {
          field: { name: 'user_id' },
          selectedMatcher: { name: 'fullMatch' },
          matchValue: userId,
        },
      ],
    };

    return this.searchAuditLogs(searchParams);
  }
}
